import { gql } from 'urql';
import { PRODUCT } from '../client';

// Polled while the provider dialog is open. Kept apart from ROUTE_FRAGMENT so
// the route list does not carry every route's quotes on every refresh.
export const GET_ROUTE_PROVIDER_DISPATCH = gql`
  query ${PRODUCT}GetRouteProviderDispatch($input: RouteInput!) {
    route(input: $input) {
      id
      thirdPartyRoute
      thirdPartyProvider
      stops {
        __typename
        ... on Delivery {
          id
        }
        ... on PickUp {
          id
        }
      }
      redeliveryStops {
        id
      }
      providerDispatch {
        status
        pickupAt
        error
        externalRouteId
        cancelRequestedAt
        cancelable
        unmarkable
        quotes {
          id
          provider
          cost
          fee
          expiresAt
        }
      }
    }
  }
`;
